class VivaCartRecommendations extends HTMLElement {
  #observer;
  #controller;
  #requestId = 0;

  connectedCallback() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) return;
        this.#observer?.disconnect();
        this.#load();
      },
      { rootMargin: '120px' }
    );
    this.#observer.observe(this);
    document.addEventListener('shopify:cart:lines-update', this.#onCartUpdate);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#controller?.abort();
    document.removeEventListener('shopify:cart:lines-update', this.#onCartUpdate);
  }

  #onCartUpdate = (event) => {
    event.promise?.then(() => {
      requestAnimationFrame(() => {
        if (this.isConnected) this.#load();
      });
    }).catch(() => {});
  };

  async #load() {
    const url = this.dataset.url;
    if (!url) return;
    this.#controller?.abort();
    this.#controller = new AbortController();
    const requestId = ++this.#requestId;

    try {
      const response = await fetch(url, { signal: this.#controller.signal, credentials: 'same-origin' });
      if (!response.ok) return;
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = documentFragment.querySelector('[data-vu-cart-recs-result]');
      if (!this.isConnected || requestId !== this.#requestId) return;
      if (result) {
        // Keep the result wrapper: category fallbacks and product cards use
        // their own layout classes, and their forms upgrade after insertion.
        this.replaceChildren(result);
        this.hidden = false;
      } else {
        this.replaceChildren();
        this.hidden = true;
      }
    } catch (error) {
      // The server-rendered category links remain useful if the request fails.
      if (error.name !== 'AbortError' && !this.children.length) this.hidden = true;
    }
  }
}

if (!customElements.get('viva-cart-recommendations')) {
  customElements.define('viva-cart-recommendations', VivaCartRecommendations);
}
